import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { I360ValidationModule } from 'app/utils/validator/validation.module';
import { I360LoaderModule } from 'app/utils/loader/loader.module';
import { AuthService } from 'app/services/auth';
import { LoginService } from 'app/services/login';
import { CommonModule } from '@angular/common';
import { I360TranslateModule } from 'app/utils/translate/translate.module';
import { SharedModule } from 'app/core/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: LoginComponent,
                canActivate: [AuthService],
            },
        ]),
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatIconModule,
        I360ValidationModule,
        I360LoaderModule,
        CommonModule,
        I360TranslateModule,
        TranslateModule,
        SharedModule,
    ],
    exports: [
        LoginComponent,
        RouterModule,
    ],
    declarations: [
        LoginComponent,
    ],
    providers: [
        LoginService,
    ],
})
export class LoginModule {}
